import { useMemo } from "react";

export const scorePassword = (pw = "") => {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 8) s++;
  if (pw.length >= 12) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  return Math.min(4, Math.max(0, s - (pw.length < 8 ? 2 : 0)));
};

const LABELS = ["Too short", "Weak", "Fair", "Strong", "Excellent"];
const COLORS = ["bg-red-500", "bg-red-400", "bg-amber-400", "bg-emerald-400", "bg-gold"];

export function PasswordStrength({ value }) {
  const score = useMemo(() => scorePassword(value), [value]);
  if (!value) return null;
  const rule = value.length >= 8 && /[A-Za-z]/.test(value) && /\d/.test(value);
  return (
    <div data-testid="password-strength" className="mt-2">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={`h-1 flex-1 rounded-full transition-colors ${i < score ? COLORS[score] : "bg-white/10"}`} />
        ))}
      </div>
      <p data-testid="password-strength-label" className="text-[11px] mt-1.5 text-text-muted">
        <span className={score >= 3 ? "text-gold" : score === 2 ? "text-amber-300" : "text-red-400"}>{LABELS[score]}</span>
        {!rule && <> · needs 8+ characters with a letter and a number</>}
      </p>
    </div>
  );
}
